import React from "react";
import { Link } from "react-router-dom";
import { IntelligentApps1, IntelligentApps2, IntelligentApps3 } from "./data";
const IntelligentApps = () => {
  return (
    <div className="menu-right-content">
      <ul className="tabpanel-column1">
        {IntelligentApps1.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column2">
        {IntelligentApps2.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>

                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column3">
        {IntelligentApps3.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default IntelligentApps;
